import { Box, styled } from "@mui/material";
import {
  HeroSection,
  FeaturesSection,
  DashboardSection,
  BannerSection,
  GuaranteeSection,
  FAQSection
} from "../components";

import type { Feature } from "../components/FeaturesSection";

const PageContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

const ContentWrapper = styled(Box)(() => ({
  width: "100%",
  marginTop: "-50px",
  borderRadius: "50px 50px 0 0",
  backgroundColor: "var(--background-white)",
  position: "relative",
  zIndex: 2,
  display: "flex",
  justifyContent: "center",
  "@media (max-width: 600px)": {
    marginTop: "-32px",
    borderRadius: "32px 32px 0 0",
  },
}));

const ContentInner = styled(Box)(() => ({
  width: "100%",
  maxWidth: "1440px",
  padding: "106px 120px 60px 120px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "56px",
  "@media (max-width: 600px)": {
    padding: "32px 16px 32px 16px",
    gap: "32px",
  },
}));

const features: Feature[] = [
  {
    title: "Один счет для всех стран",
    description: "Не нужно открывать десятки счетов за границей.",
  },
  {
    title: "Без посредников — всё через Сферу",
    description: "Вы не взаимодействуете с банками напрямую.",
  },
  {
    title: "Все операции в одном месте",
    description: "Запросы и платежи — в едином окне.",
  },
];



export const BusinessPage = () => {
  return (
    <PageContainer>
      <HeroSection
        backgroundImage="/assets/business-hero.webp"
        title="Международная платёжная платформа"
        subtitle="Единая платформа для международных финансов: от банкинга до консалтинга"
      />
      <ContentWrapper>
        <ContentInner>
          <GuaranteeSection
            title="Сфера Бизнес"
            description="это платформа для компаний, ведущих расчёты с зарубежными контрагентами. Мы заменяем сложную цепочку посредников на один понятный интерфейс."
          />
          <FeaturesSection features={features} />
          <DashboardSection
            title="Международные B2B-платежи и FX-операции"
            description="Title"
            imageSrc="/assets/business-dashboard-1.webp"
          />
          <DashboardSection
            reverse
            title="Оплата зарубежных поставщиков и сервисов"
            description="Title"
            imageSrc="/assets/business-dashboard-2.webp"
          />

          <DashboardSection
            title="Сопровождение экспортно-импортных операций"
            description="Title"
            imageSrc="/assets/business-dashboard-3.webp"
          />

          <DashboardSection
            reverse
            title="Проверка контрагентов (KYC / KYB)"
            description="Title"
            imageSrc="/assets/business-dashboard-4.webp"
          />

          <DashboardSection
            title="Структурирование платёжных цепочек"
            description="Title"
            imageSrc="/assets/business-dashboard-5.webp"
          />

          <DashboardSection
            reverse
            title="Документооборот и контроль операций"
            description="Title"
            imageSrc="/assets/business-dashboard-6.webp"
          />

          <BannerSection
            title="Управляйте международным бизнесом легко"
            imageSrc="/assets/business-banner.webp"
            imageAlt="GTC Platform"
          />
          <FAQSection />
        </ContentInner>
      </ContentWrapper>
    </PageContainer>
  );
};
